import {ID, Response} from '../../../../../../_metronic/helpers'
export type Trigger = {
  _id?: ID
  keyword?: string,
  description?: string,
  
}

export type UsersQueryResponse = Response<Array<Trigger>>

export const initialUser: Trigger = {
  keyword : '',
  description : ''
}
